import styled from 'styled-components';
import { Checkbox } from '@rsos/base-components';

export const ShareStyledCheckbox = styled(Checkbox)`
  border-radius: 5px;

  > label {
    align-items: flex-start;

    > input {
      margin-top: 2px;
    }

    > div > div:first-child {
      font-size: 14px;
    }

    > div > div:last-child {
      font-size: 12px;
    }
  }
`;
